import { Link } from "react-router-dom";
import { Users, Gauge, Fuel, Cog, Sparkles } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL || "";
const resolveImg = (u) => (!u ? "" : u.startsWith("/api/") ? BACKEND + u : u);

export default function VehicleCard({ vehicle }) {
  const cover = resolveImg(vehicle.images?.[0] || vehicle.image_url);
  const extraCount = Math.max(0, (vehicle.images?.length || 0) - 1);
  return (
    <Link
      to={`/fahrzeug/${vehicle.id}`}
      className="group rf-card-hover block bg-white border border-[#E5E5E5] overflow-hidden rounded-sm"
      data-testid={`vehicle-card-${vehicle.id}`}
    >
      <div className="aspect-video bg-[#F4F4F4] overflow-hidden border-b border-[#E5E5E5] relative">
        <img
          src={cover}
          alt={`${vehicle.brand} ${vehicle.name}`}
          className="w-full h-full object-cover group-hover:scale-[1.04] transition-transform duration-500"
          loading="lazy"
        />
        {extraCount > 0 && (
          <div className="absolute bottom-2 right-2 bg-black/70 text-white text-[10px] font-semibold uppercase tracking-wider px-2 py-1 rounded-sm">
            +{extraCount} Bilder
          </div>
        )}
        {vehicle.special && (
          <div className="absolute top-2 left-2 bg-[#E11226] text-white text-[10px] font-semibold uppercase tracking-wider px-2 py-1 rounded-sm flex items-center gap-1">
            <Sparkles size={11} /> Sonderpreis
          </div>
        )}
        {vehicle.brand_logo_url && (
          <div className="absolute bottom-2 left-2 w-10 h-10 rounded-md bg-white/95 border border-[#E5E5E5] shadow-sm flex items-center justify-center overflow-hidden p-1.5">
            <img src={resolveImg(vehicle.brand_logo_url)} alt={vehicle.brand} className="w-full h-full object-contain" />
          </div>
        )}
      </div>
      <div className="p-5">
        <div className="flex items-start justify-between gap-3 mb-4">
          <div>
            <div className="ds-label">{vehicle.brand}</div>
            <h3 className="font-display font-bold text-xl text-[#0A0A0A] uppercase tracking-tight leading-tight mt-0.5">{vehicle.name}</h3>
          </div>
          <span className="ds-mono text-[10px] uppercase font-semibold tracking-wider px-2 py-1 bg-[#F4F4F4] border border-[#E5E5E5] text-[#0A0A0A] rounded-sm">
            {vehicle.category}
          </span>
        </div>

        <div className="grid grid-cols-2 gap-2 text-xs text-[#525252] mb-5 font-mono">
          <div className="flex items-center gap-1.5"><Users size={13} className="text-[#A3A3A3]" /> {vehicle.seats} Sitze</div>
          <div className="flex items-center gap-1.5"><Cog size={13} className="text-[#A3A3A3]" /> {vehicle.transmission}</div>
          <div className="flex items-center gap-1.5"><Fuel size={13} className="text-[#A3A3A3]" /> {vehicle.fuel}</div>
          <div className="flex items-center gap-1.5"><Gauge size={13} className="text-[#A3A3A3]" /> {vehicle.doors} Türen</div>
        </div>

        <div className="flex items-end justify-between pt-4 border-t border-[#E5E5E5]">
          <div>
            <div className="ds-label">ab / Tag</div>
            {vehicle.special && vehicle.base_price_per_day > vehicle.price_per_day && (
              <div className="text-xs text-[#A3A3A3] line-through leading-none">{vehicle.base_price_per_day.toFixed(0)}€</div>
            )}
            <div className={`rf-readout font-display font-extrabold text-3xl leading-none mt-1 ${vehicle.special ? "text-[#E11226]" : "text-[#0A0A0A]"}`}>
              {vehicle.price_per_day.toFixed(0)}<span className="text-base font-semibold text-[#525252] ml-0.5">€</span>
            </div>
          </div>
          <span className="text-xs font-semibold text-[#E11226] group-hover:underline uppercase tracking-wider ds-mono">Details →</span>
        </div>
      </div>
    </Link>
  );
}
